import { mixpanelEventTrack } from '../services/mixpanel';
import { applePayObj } from '../const/cardData';
import { isStorageItem } from '../utils/isStorageItem';

const getFareForPayments = () => {
  const fareSessionAmount = isStorageItem('fare');
  const totalAmount = fareSessionAmount?.total_amount;
  const fareAmount = totalAmount ? (totalAmount / 100).toFixed(2) : null;

  return fareAmount ? fareAmount.toString() : '0';
};

export const savePayPalPayment = (inst, isWebBooker) => {
  mixpanelEventTrack(isWebBooker ? 'payPalSelectedWebBook' : 'payPalSelected');

  inst?.collectPayPalRequest && inst?.collectPayPalRequest();
};

export const saveApplePayPayment = (inst, isWebBooker) => {
  mixpanelEventTrack(isWebBooker ? 'applePaySelectedWebBook' : 'applePaySelected');

  const data = {
    applePayObj,
    total: getPaymentTotalData(),
  };

  inst?.collectApplePayRequest && inst?.collectApplePayRequest(data);
};

export const getPaymentTotalData = () => {
  return {
    label: 'Curb Estimated Amount',
    amount: getFareForPayments(),
  };
};
